<div class="manage">
    <div class="kt-portlet__head ">
        <h3 class="popup_head"
        [ngClass]="{'clr_green': data.mode == 'Success', 'clr_red': data.mode == 'Error', 'clr_orange': data.mode == 'Warning' }">{{data.title}}</h3>
    </div>
    <div class="divider">
        <mat-divider></mat-divider>
    </div>
    <div class="d_content ">
        <p style="font-size: 14px;"> {{data.des}} </p>
    </div>
</div>


<div class="row">
    <div class="col-sm-4">
        <button mat-raised-button mat-dialog-close class="del-pad fs-12 no_wrap"> {{message.No}} </button>
    </div>
    <div class="col-sm-4">
    </div>
    <div class="col-sm-4" style="text-align:right;">
        <button mat-raised-button class="savebutton del-pad fs-12 no_wrap" (click)="confirmDelete()">
            {{message.Yes}}</button>

    </div>
</div>